import WaldoHeadshot from "../../../../src/images/Waldo_Waldman_headshot.png";
import TDavisHeadshot from "../../../../src/images/Terrell_Davis_headshot.jpeg";
import CoverImg from "../../../../src/components/cover-img";
import * as React from 'react';
export default {
  WaldoHeadshot,
  TDavisHeadshot,
  CoverImg,
  React
};